module.exports = __webpack_public_path__ + "media/water_oj.9341830b.mp4";